import React from 'react';
import UserCourseList from '../../components/UserCourseList/UserCourseList';

const MyCourses = () => {
  return (
    <div className='acntContent'>
      <h3 className='acntContent__heading'>Миний хичээлүүд</h3>

      <UserCourseList type='advanced' inUserCourses />
    </div>
  );
};

export default MyCourses;
